/**
 * Rapports API - Endpoints for agent report management
 */
import apiClient from './client';

export type RapportStatus = 'pending' | 'validated' | 'rejected';

export interface AgentRapport {
    id: string;
    agent_id: string;
    agent_name?: string;
    date_rapport: string;
    total_depo_bs: string;
    total_retrait_bs: string;
    total_depo_sol: string;
    nb_transactions: number;
    montant_caisse_bs: string | null;
    montant_caisse_sol: string | null;
    montant_caisse: string | null;
    file: string | null;
    status: RapportStatus;
    validated_by_id: string | null;
    validated_at: string | null;
    notes: string | null;
    created_at: string;
    updated_at: string;
    montant_attendu_bs: string;
    montant_attendu_sol: string;
    difference_bs: string;
    difference_sol: string;
    statut_display: string;
}

export interface RapportsListResponse {
    count: number;
    next: string | null;
    previous: string | null;
    results: AgentRapport[];
}

export interface RapportFilters {
    status?: RapportStatus;
    agent_id?: string;
    date_debut?: string;
    date_fin?: string;
    page?: number;
    page_size?: number;
}

export const rapportsApi = {
    /**
     * List all reports (paginated with filters)
     */
    async list(filters?: RapportFilters): Promise<RapportsListResponse> {
        const response = await apiClient.get('/api/transactions/rapport/history/', { params: filters });
        return response.data;
    },

    /**
     * Get report by ID
     */
    async getById(id: string): Promise<AgentRapport> {
        const response = await apiClient.get(`/api/transactions/rapport/${id}/`);
        return response.data;
    },

    /**
     * Get pending report count
     */
    async getPendingCount(): Promise<{ pending_count: number }> {
        const response = await apiClient.get('/api/transactions/rapport/pending-count/');
        return response.data;
    },

    /**
     * Validate or reject a report
     */
    async validate(id: string, action: 'validate' | 'reject', notes?: string): Promise<AgentRapport> {
        const response = await apiClient.post(`/api/transactions/rapport/${id}/validate/`, { action, notes });
        return response.data;
    },
};

export default rapportsApi;
